import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { challengeGuard } from './core/guards/challenge.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'change-password',
    canActivate: [challengeGuard],
    loadComponent: () =>
      import('./features/auth/change-password/change-password.component').then(
        m => m.ChangePasswordComponent
      ),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/home/home.component').then(m => m.HomeComponent),
        pathMatch: 'full',
      },
      {
        path: 'dukpt/status',
        loadComponent: () =>
          import('./features/dashboard/flag-toggle/flag-toggle.component').then(
            m => m.FlagToggleComponent
          ),
      },
      {
        path: 'dukpt/history',
        loadComponent: () =>
          import('./features/dashboard/audit-log/audit-log.component').then(
            m => m.AuditLogComponent
          ),
      },
    ],
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'dashboard' },
];
